// may need this to avoid blank pages in IE 11...
//import Es6Promise from 'es6-promise'
//Es6Promise.polyfill()
// or just this...
import "babel-polyfill";
// or just this...
//import 'es6-promise/auto'

import Vue from 'vue'
// window.Vue = Vue;
import VueRouter from 'vue-router'
import Meta from 'vue-meta' // to add SEO/metadata/title info

/* Bulma */
import './assets/stylesheets/mystyles.scss'; // import 'bulma/css/bulma.css';
import App from './App.vue'

import router from './router'
import store from './store/index' // import store from './store'
import axios from 'axios'

/* MCHOFF import VueSocketio from 'vue-socket.io'; */

/* Bulma */
//import './assets/stylesheets/mystyles.scss'; // import 'bulma/css/bulma.css';

import VueMq from 'vue-mq'; // for mobile responsiveness. See https://github.com/AlexandreBonaventure/vue-mq
import VueSwal from 'vue-swal'; // for feedback popup messages (small wrapper for integrating SweetAlert to Vuejs)
import VeeValidate from 'vee-validate'; // for input/form validation 

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(Meta)
/* MCHOFF Vue.use(VueSocketio, 'http://localhost:3000'); */
Vue.use(require('vue-moment'));
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 450,
    md: 1250,
    lg: Infinity,
  }
});
Vue.use(VueSwal)
Vue.use(VeeValidate);

// for image upload. Ref: https://github.com/websanova/vue-upload
Vue.use(require('@websanova/vue-upload'));
Vue.http = axios;

// to allow truncation of text strings
Vue.filter('truncate', function (text, stop, clamp) {
    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
})
/*var filter = function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};
Vue.filter('truncate', filter); */

// Vue.use(VueSocketio, socketio('http://localhost:3000'), store);
// Vue.use(VueSocketio, 'http://localhost:3000', store);

/* eslint-disable no-new */
new Vue({
  /*el: '#app',
  data: {
    product: {
      rrpPrice: 8
    },
    products: {
      rrpPrice: 8
    },
  },*/
  /* MCHOFF sockets: { // Received from server via socket.io...
    connect: function(){
      console.log('socket connected')
    },
    // updateStock: function(val){
    //   console.log('updateStock:',val)
    //   store.commit('updateStock', 40); //store.commit('updateStock', itemFromServer);
    // }
  }, */
  /* methods: {
    clickButton: function(val){
        // $socket is socket.io-client instance
        this.$socket.emit('emit_method', val);
    }
  }, */
  store,
  router,
  render: h => h(App),
}).$mount('#app')

// window.vm = vm;

// set the authorization Axios header to authenticate the API calls when refreshing the app after login

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}

/*
var vm = new Vue({
  el: '#app',
  data: {
    tempMessage: "Hiya",
  },
})*/
/*
setTimeout(function() {
	vm.tempMessage = "Goodbye world";
}, 5000);*/


// WEBPACK FOOTER //
// ./src/main.js